package com.example.mystybag.common.model

import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.painter.Painter
import androidx.compose.ui.unit.Dp
import com.example.mystybag.core.ui.theme.LocalTheme.p20
import com.example.mystybag.core.ui.theme.LocalTheme.p44
import com.example.mystybag.core.views.currentTheme

data class IconData(
    val icon            : Painter,
    val iconSize        : Dp            = p20,
    val iconColor       : Color         = currentTheme.value.colors.onPrimaryContainer,
    val circleSize      : Dp            = p44,
    val circleColor     : Color         = currentTheme.value.colors.primaryContainer
)
